__turbopack_context__.v({
  "form-block": "FormBlock-module-scss-module___7vQBa__form-block",
  "form-block__fieldset": "FormBlock-module-scss-module___7vQBa__form-block__fieldset",
  "form-block__form": "FormBlock-module-scss-module___7vQBa__form-block__form",
  "form-block__submit": "FormBlock-module-scss-module___7vQBa__form-block__submit",
  "form-block__success": "FormBlock-module-scss-module___7vQBa__form-block__success",
  "form-block__wrapper": "FormBlock-module-scss-module___7vQBa__form-block__wrapper",
});
